import { PushNotificationConfig } from "configs"

export const getNotificationOptions = () => {
  return PushNotificationConfig.options
}
